<template>
    <div class="container">
        <el-form label-width="100px" action="" inline size="mini">
            <el-form-item label="安防客诉:">
                <el-upload :on-change="handleFileChange" action="" ref="uploadForm" :auto-upload="false">
                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                </el-upload>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" class="btnClass" :loading="loading" @click="onSubmit">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { getRegion } from '../../../util/util'
export default {
    components: {},
    name: 'UserData',
    mixins: [],
    data() {
        return {
            file: '',
            loading: false
        }
    },
    mounted() { },
    methods: {
        onSubmit: function () {
            if (!this.file) {
                this.$message.error("请上传文件")
                return
            }
            this.loading = true
            let formData = new FormData()
            formData.append("file", this.file)
            let timestamp = new Date().getTime()
            let header = {
                'token': JSON.parse(localStorage.getItem('user_info'))["token"],
                'client_time': parseInt(timestamp / 1000),
                'uid': JSON.parse(localStorage.getItem('user_info'))["id"],
                'request_id': timestamp,
                'CA-KEYS': 'client_time,request_id,token,uid',
                region: getRegion('region_change')
            }
            header.signature = this.signature(timestamp, {
                method: 'POST',
                data: "",
                url: this.uri.UserUploadUrl
            }, header)
            fetch(this.uri.UserUploadUrl, {
                method: 'POST',
                body: formData,
                headers: header,
            }).then(response => response.blob()) // 将响应体转换为 Blob 对象
                .then(blob => {
                    console.log('blob -> ', blob)
                    // 创建一个临时的 URL 指向 Blob 对象
                    const url = window.URL.createObjectURL(blob)

                    // 创建一个临时的 <a> 元素
                    const link = document.createElement('a')
                    link.href = url
                    // link.download = 'filename.xlsx' // 设置下载的文件名

                    // 模拟点击链接，触发下载
                    link.click()

                    // 释放 URL 对象
                    window.URL.revokeObjectURL(url)
                    this.loading = false
                    this.$message.success('上传成功')
                })
                .catch(error => {
                    console.error('Error:', error)
                    this.loading = false
                })
        },
        handleFileChange: function (file) {
            console.log('file -> ', file)
            this.file = file.raw
        }
    },
}
</script>


<style>
.ml-3 {
    margin-left: 0.75rem;
}

.container {
    min-height: 400px;
}

.btnClass {
    color: #FFF;
    background-color: #FB6D07;
    border-color: #FB6D07;
}

.btnClass:hover,
.btnClass:active,
.btnClass:focus {
    background-color: #FB6D07;
    border-color: #FB6D07;
}
</style>